import { IonContent, IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { NestedPageHeader } from '../../components/header/page.header';
import { TenantUsers } from '../../components/tenant/tenant-users';
import { useBeaconRouter } from '../../route/route.hooks';
import { useActiveWorkspace } from '../../store/workspace/workspace.hooks';

const TenantUsersPage = (): ReactElement => {
  const { i18n } = useTranslation();
  const workspace = useActiveWorkspace();
  const { builder } = useBeaconRouter();

  let pageName: string = i18n.t('common:workspace_users');
  if (workspace?.tenant.name) {
    pageName = `${workspace.tenant.name} ${i18n.t('common:workspace_users')}`;
  }

  return (
    <IonPage>
      <NestedPageHeader
        title={pageName}
        defaultBackRoute={builder.getAdminRoute()}
      />
      <IonContent>
        <TenantUsers />
      </IonContent>
    </IonPage>
  );
};

export { TenantUsersPage };
